import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-confirm-user-pin.component',
    templateUrl: './confirm-user-pin.component.html',
    styles: [],
    standalone: false
})
export class ConfirmUserPinComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit(): void {

  }
}
